export const USER_ROLE_TYPE = {
  owner: "owner",
  admin: "admin",
  standard: "standard",
  guest: "guest",
};
